import {Link} from 'react-router-dom';
import React, { useState } from 'react';

import { FaXTwitter, FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa6";

export default function Footer(services) {

  return (
    <footer id="footer" className="footer position-relative dark-background">

      <div className="container footer-top">
        <div className="row gy-4">
          <div className="col-lg-6 col-md-12 footer-about">
            <Link to={'/'} className="logo d-flex align-items-center">
              <img src={`https://cloud.ultrastream.io/images/logo-us-large.png?d=${Math.floor(Date.now()/1000)}`} height="48" />
            </Link>
            <p>Cras fermentum odio eu feugiat lide par naso tierra. Justo eget nada terra videa magna derita valies darta donna mare fermentum iaculis eu non diam phasellus.</p>
            <div className="social-links d-flex mt-4">
              {/*<a href=""><FaXTwitter /></a>
              <a href=""><FaFacebook /></a>
              <a href=""><FaInstagram /></a>
              <a href=""><FaLinkedin /></a>*/}
            </div>
          </div>

          <div className="col-lg-3 col-6 footer-links">
            <h4>Useful Links</h4>
            <ul>
              <li><a href="#">Home</a></li>
              {services.services.map((e, i)=>{
                return (
                  <li key={i}>
                    <Link to={`/${e.replaceAll(' ','')}`}>{e[0].toUpperCase() + e.slice(1)}</Link>
                  </li>
                )
              })}
              
            </ul>
          </div>

          <div className="col-lg-3 col-6 footer-links">
            <h4>Support</h4>
            <ul>
              <li><Link to={'/docs'}>Docs</Link></li>
              <li><Link to={'/support'}>Support</Link></li>
              <li><Link to={'/terms'}>Terms of service</Link></li>
              <li><Link to={'/privacy'}>Privacy policy</Link></li>
              <li><Link to={'/cookie'}>Cookie policy</Link></li>
            </ul>
          </div>
        </div>
      </div>
      <div className="copyright text-center mt-4">
        <p>© <span>Copyright</span> <strong className="sitename"><Link to={'/'}>Ultrastream.io</Link></strong> 2024 - 2026 <span>All Rights Reserved</span></p>
      </div>
    </footer>
  );
}
